import { render, staticRenderFns } from "./MediaVideo.vue?vue&type=template&id=cff4c15c"
import script from "./MediaVideo.vue?vue&type=script&lang=js"
export * from "./MediaVideo.vue?vue&type=script&lang=js"
import style0 from "./MediaVideo.vue?vue&type=style&index=0&id=cff4c15c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports